import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate('/faculties');
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				minHeight: '50vh',
				textAlign: 'center',
				gap: 2,
			}}
		>
			<Typography variant="h1" component="h1" sx={{ fontSize: '6rem', fontWeight: 'bold', color: 'primary.main' }}>
				404
			</Typography>
			<Typography variant="h4" component="h2" gutterBottom>
				Trang không tồn tại
			</Typography>
			<Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
				Trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển.
			</Typography>
			<Button variant="contained" onClick={handleGoHome}>
				Về trang chủ
			</Button>
		</Box>
	);
}